import i18n from '@/i18n'
import $axios from './apiConnection'
import parseCatch from '@/helpers/handleErrors'
import notification from '@/mixins/simpleNotification'
import { ILayoutItem } from '@/types/dashboard'
import { ObjectAnyType } from '@/types/generic'

export interface LayoutListResponse {
    Data: Array<ILayoutItem>
    Description: string
    Status: number
}

export const LayoutApi = {
    async get (data: ObjectAnyType) {
        try {
            const { Data } = await $axios.post('/Layout/List/', data) as LayoutListResponse
            return Data || []
        } catch (e) {
            parseCatch(e, true, 'Get Layouts')
            return []
        }
    },
    async update (data: ObjectAnyType) {
        try {
            const result = await $axios.post('/Layout/Upsert/', data) as {  LayoutID: number }
            if (data.LayoutID) {
                notification.call({
                    type: 'success',
                    message: i18n.t('layout.layoutUpdatedWithSuccess')
                })
            } else {
                notification.call({
                    type: 'success',
                    message: i18n.t('layout.layoutAddedWithSuccess')
                })
            }
            return result
        } catch (e) {
            parseCatch(e, true, 'Update Account Layout')
        }
    },
    async updateStatus (data: ObjectAnyType) {
        try {
            return await $axios.post('/Layout/UpdateStatus/', data)
        } catch (e) {
            parseCatch(e, true, 'Update Layout Status')
        }
    },
}
